import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const BlogRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.blog_view === true ||
    permissions.blog_edit === true ||
    permissions.blog_create === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default BlogRouteMiddleware;
